export default function About() {
  return (
    <section
      id="om"
      data-testid="about-section"
      className="relative py-16 sm:py-24 lg:py-40 bg-cm-cream overflow-hidden"
    >
      <div className="max-w-[1280px] mx-auto px-5 sm:px-10 lg:px-16 grid lg:grid-cols-12 gap-10 sm:gap-12 lg:gap-20 items-center">
        <div className="lg:col-span-6 reveal">
          <div className="relative max-w-[480px] mx-auto">
            <div className="relative rounded-sm overflow-hidden border border-cm-line bg-cm-surface shadow-[0_30px_60px_-30px_rgba(196,139,139,0.35)]">
              <img
                src="/brand/cm-breathe.jpg"
                alt="Træk vejret — du klarer den"
                loading="lazy"
                data-testid="about-portrait"
                className="w-full h-auto block transition-transform duration-[1600ms] hover:scale-[1.02]"
              />
            </div>
            <div
              aria-hidden
              className="absolute -bottom-6 -right-6 w-32 h-32 bg-cm-beige hidden sm:block -z-10"
            />
          </div>
        </div>

        <div className="lg:col-span-6 reveal">
          <span className="ornament" data-testid="about-eyebrow">
            <em>Om mig</em>
          </span>
          <h2
            data-testid="about-headline"
            className="font-serif text-cm-ink mt-8 text-[1.85rem] sm:text-4xl lg:text-[3rem] leading-[1.16] sm:leading-[1.12] tracking-[-0.005em]"
          >
            Bag CM — Coach &amp; Motivation
          </h2>
          <div className="mt-10 space-y-6 text-cm-ink-soft leading-[1.85] max-w-xl">
            <p data-testid="about-paragraph">
              Jeg hedder Cristina Mona og er blandt andet uddannet socialrådgiver, mentor
              og coach. Det betyder, at jeg møder dig med både{" "}
              <span className="text-cm-ink">faglig tyngde</span> og et hjerte,
              der banker for menneskelig transformation.
            </p>
            <p>
              Jeg tror på, at fortiden skal anerkendes — men den behøver ikke
              definere dig.
            </p>
          </div>

          <ul className="mt-14 grid grid-cols-2 gap-x-8 gap-y-4 max-w-lg" data-testid="about-credentials">
            {[
              "Lifecoach",
              "Mastercoach",
              "Stresscoach",
              "Relationshipcoach",
              "NADA-udøver",
              "Socialrådgiver",
            ].map((c) => (
              <li
                key={c}
                className="flex items-center gap-3 text-cm-ink"
              >
                <span className="w-1.5 h-1.5 rounded-full bg-cm-rose" />
                <span className="font-serif text-lg">{c}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
